/*eslint-disable*/
import TicketMessageApi from '../../api/communication/ticket-messages';
import TicketApi from "../../api/communication/ticket";
import api from '../../api/index';
import _ from "lodash";

export default {
    mounted () {
        this.$echo.private(`ticket-message.${this.user.id}`).listen('NewTicketMessage', data => {
            data = api.convertObjectKeys(data);
            if (this.receiver || this.messages) {
                if (this.ticket && data.message.ticketId === this.ticket.id) {
                    let message = data.message.ticket.lastMessage;
                    this.messages.push(message);
                    this.$nextTick(() => {
                        if (this.$refs[message.id]) {
                            this.$refs[message.id][0].scrollIntoView();
                        }
                    });
                } else if (data.message.ticket.createdAt === data.message.ticket.updatedAt) {
                    this.amountOfActive++;
                }
            } else if (this.tickets) {
                let ticket = data.message.ticket;
                let index = this.tickets.findIndex(item => item.id === ticket.id);
                if (index !== -1) {
                    this.tickets[index].lastMessage = ticket.lastMessage;
                    this.tickets.unshift(this.tickets[index]);
                    this.tickets = _.uniqBy(this.tickets, 'id');
                } else {
                    TicketApi.show(ticket.id)
                        .then(ticket => {
                            if (ticket.createdAt === ticket.updatedAt) {
                                this.amountOfActive++;
                            }
                            if (this.form.status || this.form.all) {
                                this.tickets.unshift(ticket);
                                this.tickets = _.uniqBy(this.tickets, 'id');
                                this.tickets = this.tickets.slice(0, this.amount ? this.amount : 15);
                                return TicketMessageApi.list({
                                    ticketId: ticket.id,
                                    amountOfElements: 2
                                });
                            }
                        })
                }
            }
        });
        this.$echo.private(`ticket.${this.user.id}`).listen('TicketEvent', data => {
            data = api.convertObjectKeys(data);
            let ticket = data.ticket;
            if (this.receiver || this.messages) {
                if (ticket.deletedAt) {
                    ticket.status ? this.amountOfActive-- : this.amountOfResolved--;
                }
            } else if (this.tickets) {
                let index = this.tickets.findIndex(item => item.id === ticket.id);
                if (index !== -1) {
                    if (ticket.deletedAt) {
                        this.tickets.splice(index, 1);
                        ticket.status ? this.amountOfActive-- : this.amountOfResolved--;
                        return;
                    }
                    if (this.statusState) {
                        this.tickets.splice(index, 1);
                    } else {
                        this.tickets.unshift(this.tickets[index]);
                    }
                } else {
                    if (!ticket.deletedAt) {
                        this.tickets.unshift(ticket);
                    } else {
                        ticket.status ? this.amountOfActive-- : this.amountOfResolved--;
                        return;
                    }
                }
                this.tickets = _.uniqBy(this.tickets, 'id');
            }
            if (ticket.status) {
                this.amountOfActive++;
                this.amountOfResolved--;
            } else {
                this.amountOfActive--;
                this.amountOfResolved++;
            }
        });
    }
}
